
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/sliding-doors",
      function () {
        return require("private-next-pages/alu/sliding-doors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/sliding-doors"])
      });
    }
  